export const PARAM_NAME_TOKEN = "auth-tknv2";